import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f2c7bd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_6 = { class: "general" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Crear Cliente")
], -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "no"
}, "No.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo"
}, "Tipo:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "ARS", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Centro", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Paciente", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Otro", -1))
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "rnc"
}, "RNC / Cédula:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre"
}, "Nombre:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "descripcion"
}, "Descripción:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccion"
}, "Dirección:", -1))
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Contacto")
], -1))
const _hoisted_24 = { class: "grid" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "razonSocial"
}, "Teléfonos:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "razonSocial"
}, "Emails:", -1))
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Tributarios")
], -1))
const _hoisted_29 = { class: "grid" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "razonSocial"
}, "Razón Social:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo"
}, "Tipo Persona:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Jurídica", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Física", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo"
}, "Tipo Comprobante:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "B01 - Factura de Crédito Fiscal", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "B15 - Comprobante Gubernamental", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Otros")
], -1))
const _hoisted_41 = { class: "grid" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "observaciones"
}, "Observaciones:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "estatus"
}, "Estatus:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Activo", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Inactivo", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/clientes"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "no",
                  type: "no",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cliente.no) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.no]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("select", {
                  id: "tipo",
                  type: "tipo",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cliente.tipo) = $event)),
                  class: "form-select",
                  autofocus: ""
                }, _hoisted_17, 512), [
                  [_vModelSelect, _ctx.cliente.tipo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  id: "rnc",
                  type: "rnc",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cliente.rnc) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.rnc]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  id: "nombre",
                  type: "nombre",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cliente.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.nombre]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  id: "descripcion",
                  type: "descripcion",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cliente.descripcion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.descripcion]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _withDirectives(_createElementVNode("input", {
                  id: "direccion",
                  type: "direccion",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cliente.direccion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.direccion]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("textarea", {
                  rows: "3",
                  id: "telefonos",
                  type: "telefonos",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cliente.telefonos) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.telefonos]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _withDirectives(_createElementVNode("textarea", {
                  rows: "3",
                  id: "email",
                  type: "email",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cliente.email) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.email]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", null, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  id: "razonSocial",
                  type: "razonSocial",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cliente.razonSocial) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.razonSocial]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_31,
                _withDirectives(_createElementVNode("select", {
                  id: "tipoPersona",
                  type: "tipoPersona",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cliente.tipoPersona) = $event)),
                  class: "form-select"
                }, _hoisted_34, 512), [
                  [_vModelSelect, _ctx.cliente.tipoPersona]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_35,
                _withDirectives(_createElementVNode("select", {
                  id: "tipoComprobante",
                  type: "tipoComprobante",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cliente.tipoComprobante) = $event)),
                  class: "form-select"
                }, _hoisted_38, 512), [
                  [_vModelSelect, _ctx.cliente.tipoComprobante]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  id: "observaciones",
                  type: "observaciones",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cliente.observaciones) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cliente.observaciones]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("select", {
                  id: "estatus",
                  type: "estatus",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cliente.estatus) = $event)),
                  class: "form-select"
                }, _hoisted_46, 512), [
                  [_vModelSelect, _ctx.cliente.estatus]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.saveCliente()), ["prevent"])),
            disabled: 
            !_ctx.cliente.tipo ||
            !_ctx.cliente.rnc ||
            !_ctx.cliente.razonSocial ||
            !_ctx.cliente.nombre ||
            !_ctx.cliente.descripcion ||
            !_ctx.cliente.direccion ||
            !_ctx.cliente.tipoPersona ||
            !_ctx.cliente.tipoComprobante ||
            !_ctx.cliente.telefonos ||
            !_ctx.cliente.email ||
            !_ctx.cliente.estatus
          
          }, " Guardar ", 8, _hoisted_47)
        ])
      ])
    ])
  ], 64))
}